import React from 'react';
import { BodyText, Button, Heading, UnexpectedErrorIllustration } from '@placer-ui/components';
import styles from './unexpected-exception.module.scss';

interface UncaughtExceptionComponentProps {
    drawerSize: number;
    resetErrorBoundary: () => void;
}

export const UncaughtExceptionComponent = ({ drawerSize, resetErrorBoundary }: UncaughtExceptionComponentProps) => {
    return (
        <div className={styles.uncaughtException}>
            <UnexpectedErrorIllustration size={drawerSize} />
            <Heading variant={'h3'}>
                Something Went Wrong
            </Heading>
            <div className={styles.bodyTextWrapper}>
                <BodyText size={'small'} color={'secondary'}>
                    Please try again or contact support if the issue persists.
                </BodyText>
            </div>
            <Button onClick={resetErrorBoundary} testId={'pi-uncaught-exception-button'}>
                Try Again
            </Button>
        </div>

    );
};
